import { useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { useProjectAccess } from '@/hooks'
import { EXPORT_PERMISSION } from '@/permissions/project/definitions'
import { selectIsLoading } from '@/store'
import { usePdf } from './usePdf'

export const useExportAsPdf = () => {
  const { hasAccess: exportable } = useProjectAccess(
    EXPORT_PERMISSION.FILE_FORMATS
  )

  const loading = useSelector(selectIsLoading('export_pdf'))

  const { submit: exportPdf } = usePdf('export_pdf')

  return async () => {
    if (loading || !exportable) {
      return
    }

    sendGtmEvent(
      GtmTriggerName.EXPORT_PDF,
      'Clicked on PDF button on Share modal.'
    )

    await exportPdf()
  }
}
